import { render, staticRenderFns } from "./houseForm.vue?vue&type=template&id=12844b1f&scoped=true"
import script from "./houseForm.vue?vue&type=script&lang=js"
export * from "./houseForm.vue?vue&type=script&lang=js"
import style0 from "./houseForm.vue?vue&type=style&index=0&id=12844b1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12844b1f",
  null
  
)

export default component.exports